/** @jsx jsx */
import { jsx } from "theme-ui"
import { Themed } from "@theme-ui/mdx"
import { Grid } from "@theme-ui/components"
import PropTypes from "prop-types"
import { rem } from "@src/theme"
import Banner from "@components/Banner"
import ButtonLink from "@components/ButtonLink"

const CalloutBlock = ({
    title,
    heading,
    body,
    image,
    cta,
    bannerBg = "violet",
    bannerColour = "darkPurple",
    fluidWidth = false,
    vimeoUrl = ''
}) => (
    <div
        sx={{
            py: [10, null, 16],
        }}
    >
        <Grid
            gap={[4, 5]}
            columns={[1, null, null, 2]}
            sx={{
                width: fluidWidth ? "100%" : "80%",
                mx: "auto",
            }}
        >
            <div
                sx={{
                    height: vimeoUrl ? 'auto' : [rem(250), rem(350), null, '100%'],
                    width: "100%",
                    maxHeight: rem(600)
                }}
            >
                {vimeoUrl ? (() => {
                    const url = vimeoUrl.split("?")[0]
                    const parts = url.split("/")
                    const videoId = parts[3]
                    const h = parts[4]
                    return (
                        <iframe
                            src={`https://player.vimeo.com/video/${videoId}?h=${h}&muted=1&autoplay=1`}
                            allow="autoplay; fullscreen"
                            allowFullScreen
                            sx={{
                                aspectRatio: "16 / 9",
                                width: "100%",
                                height: "auto",
                                border: "none",
                            }}
                        />
                    )
                })() : (
                    <img src={image} className="object-fit" />
                )}
            </div>

            <div sx={{}}>
                <div>
                    {title ? (
                        <div
                            sx={{
                                mb: 4,
                            }}
                        >
                            <Banner
                                title={title}
                                bannerBg={bannerBg}
                                bannerColor={bannerColour}
                            />
                        </div>
                    ) : null}
                    <Themed.h3
                        sx={{
                            mt: rem(8),
                            mb: 3,
                            lineHeight: 0.95,
                            fontSize: ["", rem(64)],
                        }}
                    >
                        {heading}
                    </Themed.h3>
                    {body && (
                        <p
                            sx={{
                                mb: 1,
                                mt: rem(10),
                                fontSize: [rem(18), rem(22)],
                                lineHeight: 1.3,
                                whiteSpace: 'break-spaces'
                            }}
                        >
                            {body}
                        </p>
                    )}
                    {cta?.link && (
                        <ButtonLink
                            styles={{
                                mt: 4,
                            }}
                            to={cta.link}
                        >
                            {cta.text}
                        </ButtonLink>
                    )}
                </div>
            </div>
        </Grid >
    </div >
)

export default CalloutBlock

CalloutBlock.propTypes = {
    heading: PropTypes.string,
    body: PropTypes.string,
    image: PropTypes.string,
}
